import {Component, EventEmitter, Input, OnInit, Output,} from '@angular/core';
import {Store} from '@ngxs/store';
import {IAppointment} from '../../models/appointment';
import {IClinicalObjective} from '../../models/clinic';
import {INotesByUser} from '../../models/service';

@Component({
  selector: 'app-old-appointments-table',
  templateUrl: './old-appointments-table.component.html',
  styleUrls: ['./old-appointments-table.component.scss']
})
export class OldAppointmentsTableComponent implements OnInit {

  constructor(private store: Store) { }
  @Input() oldAppointments: { serviceId: string, clinicalObjectives: IClinicalObjective[], appointments: IAppointment[] }[] = [];
  @Input() maxVisibleRows = 5;
  @Input() hidden = false;
  @Input() userType: 'patient' | 'expert';
  @Output() mainAction = new EventEmitter<IAppointment>();
  @Output() addNote = new EventEmitter<string>();
  @Output() noteAction = new EventEmitter<{ serviceId: string, appointmentId: string, usersAppointment: any[] }>();
  notesByUsers: INotesByUser[] = [];
  ngOnInit(): void {
  }

  onEmitViewNotes(serviceId: string, appointmentId: string, usersAppointment: any[]): void {
    this.noteAction.emit({ serviceId, appointmentId, usersAppointment });
  }

  onEmitAddNote(appointmentId: string): void {
    this.addNote.emit(appointmentId);
  }
}
